import React from 'react';
import { FormattedMessage } from 'react-intl';

const RoutePlanVehiclePreview = ({ vehicle, gray }) => {
  return (
    <div className={`m-b-2 route-plan-vehicle ${gray ? 'm-gray' : ''}`}>
      <div className="m-b-1">
        <strong>
          🚚{' '}
          {vehicle.vehicleId ? (
            vehicle.vehicleId
          ) : (
            <FormattedMessage id={`admin.vehicle.types.${vehicle.vehicleType}`} />
          )}
        </strong>
      </div>
      <div>
        <small>
          <FormattedMessage id={'route.planning.vehicle.preview.count'} values={{ value: vehicle.count }} />
        </small>
      </div>
      <div>
        <small>
          <FormattedMessage id={'route.planning.vehicle.preview.capacity'} values={{ value: vehicle.capacity }} />
        </small>
      </div>
      {vehicle.maxTravelTimeInMinutes ? (
        <div>
          <small>
            <FormattedMessage
              id={'route.planning.vehicle.preview.max.travel.time.in.minutes'}
              values={{ value: vehicle.maxTravelTimeInMinutes }}
            />
          </small>
        </div>
      ) : (
        ''
      )}
      {vehicle.maxLateTimeInMinutes ? (
        <div>
          <small>
            <FormattedMessage
              id={'route.planning.vehicle.preview.max.late.time.in.minutes'}
              values={{ value: vehicle.maxLateTimeInMinutes }}
            />
          </small>
        </div>
      ) : (
        ''
      )}
      {vehicle.routingProfileName ? (
        <div>
          <small>
            <FormattedMessage
              id={'route.planning.vehicle.preview.routing.profile.name'}
              values={{ value: vehicle.routingProfileName }}
            />
          </small>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default RoutePlanVehiclePreview;
